/**
 * Global Search - English Translations
 */

export const globalSearchEn = {
  globalSearch: {
    title: 'Search',
    placeholder: 'Search orders, shipments, locations...',
    shortcut: 'Press',
    shortcutKey: 'K',
    noResults: 'No results found',
    noResultsDescription: 'Try adjusting your search terms',
    loading: 'Searching...',
    error: 'Search failed',
    minChars: 'Type at least 2 characters',
    results: {
      orders: 'Orders',
      salesOrders: 'Sales Orders',
      shipments: 'Shipments',
      locations: 'Locations',
      visitors: 'Visitors',
      visits: 'Visits',
      gates: 'Gates',
      zones: 'Zones',
      drivers: 'Drivers',
      assets: 'Assets',
      tenants: 'Tenants',
      invoices: 'Invoices',
      products: 'Products',
    },
    viewAll: 'View all results',
    recent: 'Recent searches',
    clear: 'Clear',
  },
}
